import "./ProductDevelopmentConsulting.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import CaseStudies from "./sections/CaseStudies";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function ProductDevelopmentConsultingPage() {
  return <div>
      <Header />
      <OurServices />
      <CaseStudies />
      <ContactUs />
      <Footer />
    </div>;
}